import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Flex from '@client/components/flex/Flex';
import SwipeCarousel from '@client/components/carousels/swipeCarousel/SwipeCarousel';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import { getImagesByLanguage } from './lngUtils';
import styles from './theApp.scss';

const sliderParams = {
  spaceBetween: 100,
  slidesPerView: 1.3,
  centeredSlides: true,
  loopedSlides: 4,
  loop: false,
};

const getScreensCopy = (i18n) => {
  const language = i18n.language ?? 'sv';
  const { t } = i18n;
  return [
    {
      image: getImagesByLanguage(language).screen1,
      title: t('landing:theApp.screen1.title'),
      description: t('landing:theApp.screen1.description'),
    },
    {
      image: getImagesByLanguage(language).screen2,
      title: t('landing:theApp.screen2.title'),
      description: t('landing:theApp.screen2.description'),
    },
    {
      image: getImagesByLanguage(language).screen3,
      title: t('landing:theApp.screen3.title'),
      description: t('landing:theApp.screen3.description'),
    },
    {
      image: getImagesByLanguage(language).screen4,
      title: t('landing:theApp.screen4.title'),
      description: t('landing:theApp.screen4.description'),
    },
  ];
};

function TheApp() {
  const { t, i18n } = useTranslation(['landing']);

  const getMappedScreens = () => {
    return getScreensCopy(i18n).map((obj) => {
      return (
        <Flex key={obj.title} justifyCenter>
          <CarouselElement
            title={obj.title}
            description={obj.description}
            image={obj.image}
          />
        </Flex>
      );
    });
  };

  const mappedScreens = getMappedScreens();

  return (
    <div className={styles.theAppSection}>
      <Flex
        column
        className={classNames(
          styleHelper.landingPageSectionContent,
          styles.contentContainer
        )}
      >
        <h4 className={styleHelper.landingDefaultText}>
          {t('landing:theApp.leadText')}
        </h4>
        <h2 className={classNames(styleHelper.landingH3, styleHelper.mgt16)}>
          {t('landing:theApp.title')}
        </h2>
        <SwipeCarousel
          className={styles.hideOnTablet}
          containerClass={classNames(
            styleHelper.mgt48,
            styles.carouselContainer
          )}
          {...sliderParams}
        >
          {mappedScreens}
        </SwipeCarousel>
        <Flex
          flexNr={1}
          spaceBetween
          className={classNames(styleHelper.mgt48, styles.hideOnMobile)}
        >
          {mappedScreens}
        </Flex>
      </Flex>
    </div>
  );
}

export default TheApp;

const CarouselElement = ({ image, title, description }) => {
  return (
    <div className={styles.carouselElement}>
      <img src={image} alt={title} className={styles.carouselElementImage} />
      <h4 className={classNames(styleHelper.mgt24, styleHelper.landingH4)}>
        {title}
      </h4>
      <p
        className={classNames(
          styleHelper.mgt16,
          styleHelper.landingP3,
          styles.carouselElementDescription
        )}
      >
        {description}
      </p>
    </div>
  );
};

CarouselElement.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};
